import React, { useState, useEffect } from 'react';
import Skeleton from './Skeleton';

// Component that mimics a div with background-image, but with a skeleton loader
const BackgroundImageWithLoader = ({ src, children, style, className, onClick, ...props }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(false); // Reset loaded state when src changes
        if (!src) return;

        const img = new Image();
        img.src = src;
        img.onload = () => {
            setLoaded(true);
        };
        img.onerror = () => {
            // Handle error if needed, maybe show a fallback or just show the skeleton? 
            // For now, let's keep skeleton or maybe set loaded to show broken image placeholder if we had one.
            // We'll just set loaded to true so at least the background tries to render (and maybe fails visibly or transparently).
            setLoaded(true);
        }
    }, [src]);

    return (
        <div
            className={className}
            onClick={onClick}
            style={{
                ...style,
                position: 'relative',
                // Ensure we don't have the background image on the container itself if we want to separate the loader logic clean,
                // BUT to keep it simple, we can toggle the background image on this container.
                backgroundImage: loaded ? `url(${src})` : 'none',
                // We keep other background properties from 'style' passed in.
            }}
            {...props}
        >
            {!loaded && (
                <Skeleton
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 0, // Behind children but visible if background is missing
                        borderRadius: style?.borderRadius || 0 // Match border radius if possible
                    }}
                />
            )}
            {/* 
         If loaded is false, we show skeleton. 
         If loaded is true, we show background image (via style prop update).
         Children are always rendered on top (provided they have higher z-index or natural stacking order).
         The skeleton uses z-index 0. Ideally content should be z-index 1.
      */}
            {children}
        </div>
    );
};

export default BackgroundImageWithLoader;
